var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrugLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "libre-medical-drug logo",
    clipPath: "url(#clip0_95_81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.2728 4.74145L11.057 19.9473C7.42229 23.1577 6.78561 28.2338 9.63796 31.2627C12.4904 34.2917 17.7683 34.1442 21.403 30.9338L38.6188 15.7279C42.253 12.5181 42.8895 7.44173 40.037 4.41272C37.1847 1.38379 31.9072 1.5313 28.2728 4.74145ZM14.8614 20.5961C10.272 24.6497 11.8731 26.9627 11.8903 26.9857C12.1172 27.2968 12.0294 27.7544 11.6992 28.046C11.6762 28.0663 11.6517 28.0863 11.6253 28.1036C11.236 28.3894 10.7228 28.3498 10.4799 28.017C10.3791 27.879 8.08306 24.5855 13.8344 19.5056C14.1953 19.1868 14.7181 19.1719 15.0016 19.4729C15.2851 19.774 15.2218 20.2761 14.8605 20.5952L14.8614 20.5961ZM37.3361 14.3659L31.7793 19.2739L23.9986 11.0116L29.5555 6.10354C32.2891 3.68909 36.2581 3.57838 38.4029 5.85603C40.548 8.13401 40.0696 11.9515 37.3361 14.3659Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugLogo);
export default __webpack_public_path__ + "static/media/drug_logo.77d3fe4fff16ec0ab920bbfee00fb41f.svg";
export { ForwardRef as ReactComponent };